import { http } from '@/shared/api/client';
import type { ClientContact } from '@/shared/types/client';

interface ContractSigner {
  name: string;
  email: string;
}

export interface PublicClientDraftInput {
  filled_by: string;
  legal_name: string;
  name_client: string;
  cnpj: string;
  state_registration: string;
  email_client: string;
  phone?: string;
  whatsapp?: string;
  zipcode?: string;
  address?: string;
  number?: string;
  complement?: string;
  city?: string;
  state?: string;
  sector?: string;
  type?: string;
  site?: string;
  pdv?: string;
  billing_emails: string;
  financial_contact_phone: string;
  contract_witness_email: string;
  contractSigners: ContractSigner[];
  models: string[];
  contacts: ClientContact[];
  /** Honeypot — deve ficar sempre vazio; um humano não vê nem preenche este campo. */
  website?: string;
}

export async function submitPublicClientDraft(payload: PublicClientDraftInput) {
  const body = {
    ...payload,
    models: payload.models.join(','),
    contacts: JSON.stringify(payload.contacts ?? []),
    contractSigners: JSON.stringify(payload.contractSigners ?? []),
  };
  await http.post('/bff/public/client-draft', body);
}
